export enum StepperActionsEnum {
  viewOtherAccounts = "viewOtherAccounts",
  completeSteps = "completeSteps",
}
